import Base from 'src/storage/base';

class MobileModel extends Base {
  id = 'allstats';
  defaultState = () => ({
    minAppVersion: '',
    logoutAppVersion: '',
    settings: {}
  });
  apiConfig = {
    loadSettings: {
      url: 'admin/settings/getMobile',
      validation: {},
      cancellable: true
    },
    setSettings: {
      url: 'admin/settings/setMobile',
      validation: {
        minAppVersion: 'semver',
        logoutAppVersion: 'semver'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  loadSettings = () => {
    this.api('loadSettings', {}, (err, res, success) => {
      console.log('loadSettings', err, res, success);
      if (success) {
        this.setState({
          minAppVersion: res.minAppVersion,
          logoutAppVersion: res.logoutAppVersion,
          settings: res
        });
      }
    });
  };

  saveSettings = () => {
    // this.handleChange('minAppVersion', semver.clean(this.input('minAppVersion')) || '');
    // this.handleChange('logoutAppVersion', semver.clean(this.input('logoutAppVersion')) || '');
    this.api(
      'setSettings',
      {
        minAppVersion: this.input('minAppVersion'),
        logoutAppVersion: this.input('logoutAppVersion')
      },
      (err, res, success) => {
        console.log('saveSettings', err, res, success);
        // if (!success) {
        //   this.setState({ ...this.state.settings });
        //   alert('error: ' + err);
        // }
      }
    );
  };
}

const model = new MobileModel();
export default model;
